import { Box, Pagination } from "@mui/material";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import axios from "../../../api/axios";
import {
  hsCodesState,
  hsCodesPageState,
  hsCodesTotalPageState,
} from "../../../atoms/membership";
import miniLogo from "../../../img/logos/logo_white_mini_loading.svg";
import HSCodesListItem from "./HSCodesListItem";
import Errors from "../../../utils/Errors";

const HSCodesList = () => {
  const [loading, setLoading] = useState(true);
  const [hsCodes, setHsCodes] = useRecoilState(hsCodesState);
  const [hsCodesPage, setHsCodesPage] = useRecoilState(hsCodesPageState);
  const [hsCodesTotalPage, setHsCodesTotalPage] = useRecoilState(hsCodesTotalPageState);

  const getHsCodesList = useCallback(async () => {
    setLoading(true);
    axios
      .get(`member-hs-code`)
      .then((response) => {
        setHsCodes(response.data.data);
        setLoading(false);
        setHsCodesPage(1);
        setHsCodesTotalPage(response.data.totalPages);
      })
      .catch((error) => {
        Errors(error);
        setLoading(false);
      });
  }, [setHsCodes, setHsCodesPage, setHsCodesTotalPage]);

  const refreshList = useCallback(() => {
    getHsCodesList();
  }, [getHsCodesList]);

  const handlePageChange = useCallback(
    (e, pageValue) => {
      setLoading(true);
      axios
        .get(`member-hs-code`)
        .then((response) => {
          setHsCodes(response.data.data);
          setLoading(false);
          setHsCodesTotalPage(response.data.totalPages);
          setHsCodesPage(pageValue);
        })
        .catch((error) => {
          Errors(error);
          setLoading(false);
        });
    },
    [setHsCodes, setHsCodesTotalPage, setHsCodesPage]
  );

  useEffect(() => {
    getHsCodesList();
  }, [getHsCodesList]);

  return (
    <Box className="address-list">
      <Box
        sx={
          loading
            ? { marginTop: "20px", display: "flex", justifyContent: "center" }
            : {
                marginTop: "20px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(228px, 1fr))",
                gap: "var(--gap)",
              }
        }
      >
        {loading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <img className="loading-logo" src={miniLogo} alt="" />
          </div>
        ) : (
          <>
            {hsCodes.length === 0 &&
              "Kayıtlı HS Kodu bulunmamaktadır."}
            {hsCodes
              .filter((hsCode) => hsCode.deleted === "0")
              .map((hsCode) => (
                <div
                  key={hsCode.id}
                  style={{
                    maxWidth: "230px",
                    width: "100%",
                    borderRadius: "var(--inputBorderRadius)",
                    border: "1px solid var(--inputBorderColor)",
                    position: "relative",
                  }}
                >
                  {hsCode.is_default === 1 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        backgroundColor: "var(--warning)",
                        color: "white",
                        borderRadius: "50%",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "bold",
                        zIndex: 1,
                      }}
                      title="Varsayılan HS Kodu"
                    >
                      ★
                    </div>
                  )}
                  <HSCodesListItem hsCode={hsCode} onRefresh={refreshList} />
                </div>
              ))}
          </>
        )}
      </Box>
      {!loading && hsCodesTotalPage > 1 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Pagination
            count={hsCodesTotalPage}
            page={hsCodesPage}
            onChange={handlePageChange}
            color="primary"
            size="small"
          />
        </Box>
      )}
    </Box>
  );
};

export default HSCodesList;
